import './About.css'
import React, { Component } from 'react'
import Footer from './Footer'
import rwd from '../../assets/images/rwd.png'
import photography from '../../assets/images/photography.png'
import progressivewebapp from '../../assets/images/progressivewebapp.png'
import prototype from '../../assets/images/prototype.png'
import ui from '../../assets/images/ui.png'

class About extends Component {
	componentDidMount() {
		document.title = 'About'
	}
	render() {
		return (
			<div className="Site-Content">
				<main className="About">
					<header className="About-Head">
						<h1 className="About-Title">
							Hi, I am Vishal Gautam, a Fullstack Developer from Toronto,
							Ontario
						</h1>
						<p className="About-Description">
							I am skilled in the following areas
						</p>
					</header>

					<section className="About-Skills">
						<figure className="stepimage step01-image">
							<img src={rwd} alt="RWD" />
							{/* <figcaption>
								<p className="item-desc">RWD &mdash; Responsive Web Development</p>
							</figcaption> */}
						</figure>
						{/* <!-- .step01-image --> */}
						<div className="Skill Skill01-body">
							<h2 className="Skill-Title"> Responsive Web Design </h2>
							<p>
								I have gained a lot of experience designing and developing many
								responsive websites
							</p>
						</div>

						<figure className="stepimage step02-image">
							<img src={ui} alt="UI Development" />
							{/* <figcaption>
								<p className="item-desc">2. UI Development</p>
							</figcaption> */}
						</figure>
						{/* <!-- .step02-image --> */}
						<div className="Skill Skill02-body">
							<h2 className="Skill-Title"> UI Development </h2>
							<p>
								I love developing User Interface that provides rich and
								consistent user expernence. I have gained enough knowledge that
								I can convert a concept into a minimum viable product. I mainly
								use React Library by Facebook to build User Interfaces.
							</p>
						</div>

						<figure className="stepimage step03-image">
							<img src={photography} alt="Photography" />
							{/* <figcaption>
								<p className="item-desc">3. Photography</p>
							</figcaption> */}
						</figure>
						{/* <!-- .step03-image --> */}
						<div className="Skill Skill03-body">
							<h2 className="Skill-Title"> Photography </h2>
							<p>
								Photography is one of my oldest passion. Even though it is just
								a hobby, photography has taught me a lot of valuable skills such
								as patience and attention to detail, which has been fundamental
								to my skill as a UI developer.
							</p>
						</div>

						<figure className="stepimage step04-image">
							<img src={prototype} alt="Prototype" />
							{/* <figcaption>
								<p className="item-desc">4. Prototype</p>
							</figcaption> */}
						</figure>
						{/* <!-- .step04-image --> */}
						<div className="Skill Skill04-body">
							<h2 className="Skill-Title"> Prototype </h2>
							<p>
								Using tools like React and Elm programming language has given me
								the ability to rapidly prototype different ideas.
							</p>
						</div>

						<figure className="stepimage step05-image">
							<img src={progressivewebapp} alt="Progressive Web Apps" />
							{/* <figcaption>
								<p className="item-desc">5. progressivewebapp</p>
							</figcaption> */}
						</figure>
						{/* <!-- .step05-image --> */}
						<div className="Skill Skill05-body">
							<h2 className="Skill-Title"> Progressive Web Apps </h2>
							<p>
								Nowdays, inorder to provide excellent UX experience to users, it
								is extremely crucial for a website to be reliable, fast and
								engaging. I have the skills to build such apps
							</p>
						</div>
					</section>
				</main>
				<Footer />
			</div>
		)
	}
}

export default About



// WEBPACK FOOTER //
// ./src/components/About/About.js